import slice from './slice';

export const {clearUserData} = slice.actions;